<button rlStopPropagation class="btn btn-clear btn-link remove-btn" [id]="'remove-button-' + uniqueId" (click)="remove()" attr.value="{{'tag.action.remove' | translate}}" [rlAria]="'tag.action.remove' | translate" [rlTabIndex] [tooltip]="'tag.action.remove' | translate">
	<span class="sr-only">{{'otherResources.action.remove' | translate}}</span>
    <span>&#x2715;</span>
</button>